<template>
  <div class="ee-card-attribute input-number">
    <r-text type="caption" style="margin-bottom: 8px;">
      {{ config.label }}
    </r-text>
    <el-input-number
      :min="0"
      class="r-input"
      size="mini"
      v-model="feature[config.prop]"
    />
  </div>
</template>

<script>
export default {
  props: ["feature", "config"]
};
</script>

<style></style>
